<md-content-box class="lesson-info" [type]="hasError() ? 'error' : hasWarning() ? 'warning' : 'default'">
	@if (isPopup() === false) {
		<div class="lesson-page">
			<ng-container *ngTemplateOutlet="lessonDateBlock"></ng-container>
			<div class="lesson-info">
				<div class="lesson-date-user-actions">
					<ng-container *ngTemplateOutlet="lessonDateInfo"></ng-container>
					@if (lessonView() !== 'history') {
						<ng-container *ngTemplateOutlet="lessonUserInfo"></ng-container>
						<ng-container *ngTemplateOutlet="lessonActions"></ng-container>
					}
				</div>
				<div class="lesson-dropdowns-tags">
					<ng-container *ngTemplateOutlet="lessonDropDowns"></ng-container>
					<ng-container *ngTemplateOutlet="lessonTags"></ng-container>
				</div>
			</div>
		</div>
	}

	@if (isPopup() === true) {
		<div class="lesson-popup">
			<div class="lesson-popup-header">
				<ng-container *ngTemplateOutlet="lessonDateBlock"></ng-container>

				<div class="date-with-tags">
					<ng-container *ngTemplateOutlet="lessonDateInfo"></ng-container>
					<ng-container *ngTemplateOutlet="lessonTags"></ng-container>
				</div>
			</div>

			<div class="lesson-program-info">
				<ng-container *ngTemplateOutlet="lessonUserInfo"></ng-container>
			</div>

			<div class="lesson-dropdowns">
				<ng-container *ngTemplateOutlet="lessonDropDowns"></ng-container>
			</div>

			<div class="lesson-actions">
				<ng-container *ngTemplateOutlet="lessonActions"></ng-container>
			</div>
		</div>
	}
</md-content-box>

<ng-template #lessonDateBlock>
	<div class="lesson-date-block" [ngClass]="hasError() ? 'error' : hasWarning() ? 'warning' : 'default'">
		<div>{{ lessonDate() | tzDate: 'MMM d' }}</div>
		<div>{{ lessonDate() | tzDate: 'y' }}</div>
	</div>
</ng-template>

<ng-template #lessonDateInfo>
	<div class="lesson-date-info">
		<div class="md-text-xs-regular">{{ lessonDate() | tzDate: 'EEEE' }}</div>
		<div class="md-text-md-medium">{{ lessonDate() | tzTime: 'shortTime' }} - {{ lessonEndTime() | tzTime: 'shortTime' }}</div>
		@if (lessonTimeConversion().contextMessage) {
			<div class="md-text-xs-regular timezone-conversion-info">
				{{ lessonTimeConversion().contextMessage }}
			</div>
		}
	</div>
</ng-template>

<ng-template #lessonTags>
	<div class="lesson-tags">
		@for (tag of tags(); track $index) {
			<md-tag [type]="tag.type || 'tertiary'" class="chip--icon">
				<md-icon [icon]="tag.icon ?? 'untitled-ui/time/calendar'"></md-icon>
				{{ tag.text }}
			</md-tag>
		}
	</div>
</ng-template>

<ng-template #lessonUserInfo>
	<div class="lesson-user-info" (click)="openLink(linkView())" [ngClass]="{ clickable: isUserAdmin() }">
		<lb-user-icon [userID]="lessonUser().userID"></lb-user-icon>
		<div class="user-info">
			<span class="md-text-sm-semibold">{{ lessonUser().fullName }}</span>
			<span class="md-text-xs-regular">{{ lesson().languageName }} {{ displayedUser() === 'instructor' ? 'Instructor' : 'Learner' }}</span>
		</div>
	</div>
</ng-template>

<ng-template #lessonDropDowns>
	<div class="lesson-drop-downs">
		<ng-content select="[lesson-dropdown-area]"></ng-content>
	</div>
</ng-template>

<ng-template #lessonActions>
	<div class="lesson-actions">
		@if (!isLearnerAbsent()) {
			@if (!pendingReschedule()) {
				<!-- Maybe we can update this later to be lesson().lessonUrl but for now we are hard coding to Teams link -->
				<a href="https://teams.microsoft.com/?web=1" target="_blank" md-button-brand>Join</a>
			} @else if (lessonView() === 'learner' && !isChirpLesson()) {
				<button class="reschedule" md-button (click)="reschedule()">
					<md-icon icon="untitled-ui/time/clock-refresh"></md-icon>
					Reschedule
				</button>
			}
		}

		<md-menu [menuItems]="menuOptions()" triggerIcon="untitled-ui/general/dots-horizontal" md-button [disabled]="menuOptions().length === 0"></md-menu>
		@if (lessonDetailsEnabled()) {
			<a md-button [routerLink]="detailsLink() ?? [lesson().lessonID]"> {{ lessonView() === 'learner' ? 'Details' : isEditable() ? 'Log Lesson' : 'View Lesson' }} </a>
		}
	</div>
</ng-template>
